import sets from "@/lib/games/unionArena/data/sets.json";

// Nickname mappings for leaders
const NICKNAME_MAPPINGS: Record<string, string[]> = {};

// Create a searchable string that includes name, nicknames, and color abbreviations
const createSearchableString = (setId: string, setName: string): string => {
  const nicknames = NICKNAME_MAPPINGS[setName] || [];

  return [setName, ...nicknames, setId].join(" ").toLowerCase();
};

// Enhanced filtering function that checks name, nicknames, and color abbreviations
export const filterSets = (items: SetItem[], inputValue: string) => {
  if (!inputValue) return items;

  const searchTerms = inputValue.toLowerCase().split(" ");

  return items.filter((item) => {
    const searchableString = createSearchableString(item.id, item.name);

    // Check if all search terms are found in the searchable string
    return searchTerms.every((term) => searchableString.includes(term));
  });
};

// Create the initial items array with all necessary searchable data
export const createSetItems = (sortByName: boolean = true): SetItem[] => {
  const setItems: SetItem[] = [];
  for (const [k, v] of Object.entries(sets)) {
    setItems.push({
      id: k,
      name: v,
      searchableString: createSearchableString(k, v),
    });
  }

  return sortByName
    ? setItems.sort((a, b) => a.name.localeCompare(b.name))
    : setItems;
};

interface SetItem {
  id: string;
  name: string;
  searchableString: string;
}

export interface ArchetypeItem {
  id: string;
  idFull: string;
  key: string;
  name: string;
  value: string;
  color: string;
  count: number;
  set: string;
}

export const filterArchetypes = (
  items: ArchetypeItem[],
  inputValue: string,
) => {
  if (!inputValue) return items;

  const searchTerms = inputValue.toLowerCase().split(" ");

  return items.filter((item) => {
    const searchableString = getArchetypeSearchableString(item);
    return searchTerms.every((term) => searchableString.includes(term));
  });
};

export function getArchetypeSearchableString(item: ArchetypeItem) {
  const { set, name, color } = item;
  return [name, color, set].join(" ").toLowerCase();
}
